import AdminShell from "@/components/admin/AdminShell";
import AcademyMediaManager from "@/components/admin/AcademyMediaManager";

export default function AdminPhysicsMedia() {
  return (
    <AdminShell title="Stoic Physics · Media Slots">
      <div data-testid="admin-physics-media-page">
        <AcademyMediaManager discipline="physics" />
      </div>
    </AdminShell>
  );
}
